import { strictObjectAccess } from '@ackee/redux-utils';

export const vatMode = strictObjectAccess({
    BASE: 'base',
    FINAL: 'final',
});
